
import { CostCentreEntityDecoratorBase } from './cost-centre.decorator.base';


export class CostCentreEntityDecorator extends CostCentreEntityDecoratorBase {
  constructor() {
    super();
  }
}



